export default {"src":"/_next/static/media/uk.40fdada2.svg","height":341,"width":512,"blurWidth":0,"blurHeight":0};